const set = property => (state, payload) => (state[property] = payload)
const get = property => (state) => (state[property])
const sleep = millis => new Promise(resolve => setTimeout(resolve, millis));

export default {
  namespaced: true,
  state: {
    appError: null,
  },
  getters: {
    appError: get('appError'),
  },
  mutations: {
    setAppError: set('appError'),
  },
  actions: {
    updateAppError({ commit }, appError){ 
      commit('setAppError', appError)
    },
    async resetAppError({ commit, getters }){ 
      const curAppError = getters.appError;
      await sleep(1000)
      commit('setAppError', null);
      commit('setAppError', curAppError);
    },
  },
}
